import { render, staticRenderFns } from "./PortfolioHoldingsArea.vue?vue&type=template&id=e349dfd8&scoped=true&"
import script from "./PortfolioHoldingsArea.vue?vue&type=script&lang=js&"
export * from "./PortfolioHoldingsArea.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHoldingsArea.vue?vue&type=style&index=0&id=e349dfd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e349dfd8",
  null
  
)

export default component.exports